import React, { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Cookies from "js-cookie";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getExpenseDetails, getExpenseRemarks, getJobOrderAccountExpenseDetails } from '../../../Redux/action/Account/AccountAction';
import ErrorDynamic from '../../../Common/Unauthorized/ErrorDynamic';
import Accordion from 'react-bootstrap/Accordion';
import { capitalizeFirstLetter, convertYYYY_MM_DDTHH_MM_SS_MMSZ_to_DD_MM_YYYY } from '../../../HelperFunctions';
import { adminMainUrl } from '../../../Config';
import Beatloader from '../../../Common/Loaders/Beatloader';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useFormik } from 'formik';
import axios from 'axios';
import RoundedSmallButton from '../../../Common/RoundedButton/RoundedSmallButton';
import OverlayLoader from '../../../Common/Loaders/OverlayLoader';

const ViewJobOrderAccountExpense = ({ accessedPermission, airsea, impexp }) => {
    const { b64id } = useParams();
    const location = useLocation();
    const dispatch = useDispatch();
    const token = Cookies.get("token");
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    let user_id = Cookies.get('flexichain_user_id');
    const navigate = useNavigate();

    const [showLoader, setShowLoader] = useState(true);
    const [expenseID, setExpenseID] = useState(null);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [disableRemarkSubmit, setDisableRemarkSubmit] = useState(false);

    const [show, setShow] = useState(false);
    const [showRemark, setShowRemark] = useState(false);
    const [showRemarkInput, setShowRemarkInput] = useState(false);
    const [viewCanvasLoader, setViewCanvasLoader] = useState(false);

    const handleClose = () => {
        setShow(false);
        setShowRemark(false);
    }
    const handleShow = (expenseID) => {
        try {
            if (!expenseID) {
                toast.error("Please provide expense id to view expense details.")
            }
            setExpenseID(expenseID);
            setShow(true);

        } catch (error) {
            toast.error(error.message);
        }
    };

    useEffect(() => {
        if (token, user_id, expenseID) {
            dispatch(getExpenseDetails(token, user_id, expenseID));
            dispatch(getExpenseRemarks(token, user_id, expenseID));
        }
    }, [expenseID]);

    const handleCloseRemark = () => setShowRemark(false);
    const handleShowRemark = (expenseID) => {
        try {
            if (!expenseID) {
                toast.error("Please provide expense id to view remarks.")
            }
            dispatch(getExpenseDetails(token, user_id, expenseID));
            setExpenseID(expenseID);
            setShowRemark(true);

        } catch (error) {
            toast.error(error.message);
        }
    };





    useEffect(() => {
        if (token && user_id) {
            if (b64id) {
                let job_order_id = atob(b64id);
                if (job_order_id) {
                    dispatch(getJobOrderAccountExpenseDetails(token, user_id, job_order_id))
                } else {
                    toast.error("Please enter correct URL.");
                    navigate(-1);
                }
            } else {
                toast.error("Please enter correct URL.");
                navigate(-1);
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, b64id]);


    const refresh = () => {
        if (token && user_id) {
            if (b64id) {
                let job_order_id = atob(b64id);
                if (job_order_id) {
                    dispatch(getJobOrderAccountExpenseDetails(token, user_id, job_order_id))
                } else {
                    toast.error("Please enter correct URL.");
                    navigate(-1);
                }
            } else {
                toast.error("Please enter correct URL.");
                navigate(-1);
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }
    const refreshRemarks = () => {
        if (token && user_id && expenseID) {
            dispatch(getExpenseRemarks(token, user_id, expenseID));
        }
    }

    const {
        loadingJobOrderDetails,
        JobOrderDetailsError,
        JobOrderDetails,
        JobOrderQuotationDetails,
        JobOrderQueryDetails,
        JobOrderExpenseList,

        loadingExpenseDetails,
        ExpenseDetailsError,
        ExpenseDetails,

        loadingExpenseRemarks,
        ExpenseRemarksError,
        ExpenseRemarks,
    } = useSelector(state => state.AccountReducer);


    const [remarkMessage, setRemarkMessages] = useState([]);
    useEffect(() => {
        if (ExpenseRemarks) {
            let arr = [];
            ExpenseRemarks.map((v) => arr.push(v));
            setRemarkMessages(arr);
        }
    }, [ExpenseRemarks])


    useEffect(() => {
        if (loadingJobOrderDetails) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
    }, [
        loadingJobOrderDetails,
        JobOrderDetailsError,
        JobOrderDetails,
        JobOrderQuotationDetails,
        JobOrderQueryDetails,
        JobOrderExpenseList
    ]);


    useEffect(() => {
        if (loadingExpenseDetails) {
            setViewCanvasLoader(true);
        } else {
            setViewCanvasLoader(false);
        }

        // console.log(ExpenseDetails);
    }, [
        loadingExpenseDetails,
        ExpenseDetailsError,
        ExpenseDetails
    ]);


    const initialValues = {
        account_remark: "",
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            try {
                if (!expenseID) {
                    toast.error("Couln't find expense ID.");
                    return;
                };
                values.expense_id = expenseID;
                setDisableRemarkSubmit(true);
                let config = {
                    headers: {
                        "user_id": user_id,
                        "auth-token": token
                    }
                }
                axios.post(`${adminMainUrl}/api/account/add-account-remark`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            setDisableRemarkSubmit(false);
                            // handleClose();
                            resetForm();
                            setShowRemarkInput(false);
                            refreshRemarks();
                        } else {
                            toast.error(response.data.msg);
                            setDisableRemarkSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal server error";
                        if (error && error.response && error.response.data && error.response.data.msg) {
                            msg = error.response.data.msg;
                        };
                        toast.error(msg);
                        setDisableRemarkSubmit(false);
                    });
            } catch (error) {
                let msg = "Internal server error";
                if (error && error.message) {
                    msg = error.message;
                };
                toast.error(msg);
                setDisableRemarkSubmit(false);
            }
        }
    });

    const handleApprove = (expense_id) => {
        try {
            if (!expense_id) {
                toast.error("Couln't find expense ID.");
                return;
            };
            let values = { expense_id: expense_id };
            setDisableSubmit(true);
            let config = {
                headers: {
                    "user_id": user_id,
                    "auth-token": token
                }
            }
            axios.post(`${adminMainUrl}/api/account/approve-expense`, values, config)
                .then(response => {
                    if (response.status == 200) {
                        toast.success(response.data.msg);
                        setDisableSubmit(false);
                        handleClose();
                        refresh();
                    } else {
                        toast.error(response.data.msg);
                        setDisableSubmit(false);
                    }
                }).catch(error => {
                    console.log(error);
                    let msg = "Internal server error";
                    if (error && error.response && error.response.data && error.response.data.msg) {
                        msg = error.response.data.msg;
                    };
                    toast.error(msg);
                    setDisableSubmit(false);
                });
        } catch (error) {
            let msg = "Internal server error";
            if (error && error.message) {
                msg = error.message;
            };
            toast.error(msg);
            setDisableSubmit(false);
        }
    }


    function formatDate(dateString) {
        if (dateString) {
            const date = new Date(dateString);

            // Check if the date is valid
            if (isNaN(date.getTime())) {
                return ""; // Return an empty string if the date is invalid
            }

            const day = String(date.getDate()).padStart(2, "0");
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const month = monthNames[date.getMonth()];
            const year = date.getFullYear();

            return `${day}-${month}-${year}`;
        }
    }

    function formatTime(dateString) {
        if (!dateString) return 'Invalid date'; // handle cases where dateString is undefined or null

        const date = new Date(dateString);

        // Extract time components
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        // const seconds = String(date.getSeconds()).padStart(2, "0");

        // Return only the formatted time string
        return `${hours}:${minutes}`;
    }





    if (JobOrderDetailsError) {
        return <ErrorDynamic errormsg={JobOrderDetailsError ?? "Internal Server Error"} />
    };


    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <div className="page-wrapper">
                            <div className="content">
                                <div className="row mb-1">
                                    <div className="col-md-12">
                                        {/* Page Header */}
                                        <div className="page-header">
                                            <div className="row align-items-center">
                                                <div className="col-8">
                                                    <h4 className="page-title">
                                                        Job Order Details
                                                    </h4>
                                                </div>
                                                {JobOrderDetails.is_locked ? <div className="col-4 text-end">
                                                    <button className="btn btn-sm btn-primary "> Generate Bill</button>
                                                </div> : null}
                                            </div>
                                        </div>
                                        {/* /Page Header */}
                                    </div>
                                </div>



                                <div className="card p-1">
                                    <Accordion defaultActiveKey={['0']} alwaysOpen>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header className='my-0'>
                                                <div className="d-flex justify-content-between w-100">
                                                    <div>
                                                        Job Order Details
                                                    </div>
                                                    <div>
                                                        {JobOrderDetails.is_locked ? <i class="fa-solid fa-lock mx-2" title="This operation is locked" style={{ color: "#ff0000" }}></i> : null}
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div className="card mb-0">
                                                    <div className="card-body">
                                                        {
                                                            JobOrderDetails ?
                                                                <>
                                                                    <div className="row">
                                                                        <div className="col-md-6 my-1">
                                                                            <div className="row">
                                                                                <div className="col-md-6">
                                                                                    <label htmlFor="job_order_no" className='form-label-cus'>Job Order No.:</label>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <>{JobOrderDetails.job_order_unique_no}</>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-6 my-1">
                                                                            <div className="row">
                                                                                <div className="col-md-6">
                                                                                    <label htmlFor="tracking_no" className='form-label-cus'>Tracking No.:</label>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <>{JobOrderDetails.tracking_no}</>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-6 my-1">
                                                                            <div className="row">
                                                                                <div className="col-md-6">
                                                                                    <label htmlFor="created_by" className='form-label-cus'>Created By:</label>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <>{JobOrderDetails.created_by_userinfo ? `${JobOrderDetails.created_by_userinfo.name} (${JobOrderDetails.created_by_userinfo.email})` : ""}</>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-6 my-1">
                                                                            <div className="row">
                                                                                <div className="col-md-6">
                                                                                    <label htmlFor="created_by" className='form-label-cus'>Has Quotation:</label>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <>{JobOrderDetails.has_quotation ? "YES" : "NO"}</>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                :
                                                                <>Couldn't find Job Order details</>
                                                        }
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        {
                                            JobOrderDetails.has_quotation &&
                                            <Accordion.Item eventKey="1">
                                                <Accordion.Header className='my-0'>Quotation Details</Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="card mb-0">
                                                        <div className="card-body">
                                                            {
                                                                JobOrderQuotationDetails ?
                                                                    <>
                                                                        <div className="row">
                                                                            <div className="col-md-6 my-1">
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <label htmlFor="job_order_no" className='form-label-cus'>Quotation No.:</label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <>{JobOrderQuotationDetails.ship_quotation_no}</>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 my-1">
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <label htmlFor="tracking_no" className='form-label-cus'>Buyer Ref No.:</label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <>{JobOrderQuotationDetails.ship_buy_ref_no}</>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 my-1">
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <label htmlFor="created_by" className='form-label-cus'>Rate Validity:</label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <>{JobOrderQuotationDetails.ship_rate_validity ? convertYYYY_MM_DDTHH_MM_SS_MMSZ_to_DD_MM_YYYY(JobOrderQuotationDetails.ship_rate_validity) : ""}</>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 my-1">
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <label htmlFor="created_by" className='form-label-cus'>Date of Creation:</label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <>{JobOrderQuotationDetails.ship_date_of_creation ? convertYYYY_MM_DDTHH_MM_SS_MMSZ_to_DD_MM_YYYY(JobOrderQuotationDetails.ship_date_of_creation) : ""}</>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 my-1">
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <label htmlFor="created_by" className='form-label-cus'>Quotation given by:</label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <>{JobOrderQuotationDetails.pricing_user_info ? `${JobOrderQuotationDetails.pricing_user_info.name} (${JobOrderQuotationDetails.pricing_user_info.email})` : ""}</>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <>Couldn't find Quotation Order details</>
                                                            }
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        }
                                        {
                                            JobOrderDetails.has_quotation &&
                                            <Accordion.Item eventKey="2">
                                                <Accordion.Header className='my-0'>Query Details</Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="card mb-0">
                                                        <div className="card-body">
                                                            {
                                                                JobOrderQueryDetails ?
                                                                    <>
                                                                        <div className="row">
                                                                            <div className="col-md-6 my-1">
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <label htmlFor="job_order_no" className='form-label-cus'>Request No.:</label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <>{JobOrderQueryDetails.request_no}</>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 my-1">
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <label htmlFor="tracking_no" className='form-label-cus'>Shipment mode:</label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <>{JobOrderQueryDetails.shipment_mode ? capitalizeFirstLetter(JobOrderQueryDetails.shipment_mode) : ""}</>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 my-1">
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <label htmlFor="created_by" className='form-label-cus'>Shipment Type:</label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <>{JobOrderQueryDetails.quotation_user_type == "IMPORTER" ? "Import" : JobOrderQueryDetails.quotation_user_type == "EXPORTER" ? "Export" : ""}</>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 my-1">
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <label htmlFor="created_by" className='form-label-cus'>Service Type:</label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <>{JobOrderQueryDetails.service_type}</>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 my-1">
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <label htmlFor="created_by" className='form-label-cus'>Name:</label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <>{JobOrderQueryDetails.full_name}</>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 my-1">
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <label htmlFor="created_by" className='form-label-cus'>Email:</label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <>{JobOrderQueryDetails.email}</>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 my-1">
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <label htmlFor="created_by" className='form-label-cus'>Phone:</label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <>{JobOrderQueryDetails.phone}</>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 my-1">
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <label htmlFor="created_by" className='form-label-cus'>Cargo Ready Date:</label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <>{JobOrderQueryDetails.cargo_ready_date}</>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6 my-1">
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <label htmlFor="created_by" className='form-label-cus'>Query Picked by:</label>
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <>{JobOrderQueryDetails.picked_user_info ? `${JobOrderQueryDetails.picked_user_info.name} (${JobOrderQueryDetails.picked_user_info.email})` : ""}</>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <>Couldn't find Query details</>
                                                            }
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        }
                                        <Accordion.Item eventKey="3">
                                            <Accordion.Header className='my-0'>Expense Details</Accordion.Header>
                                            <Accordion.Body>
                                                <div className="card">
                                                    <table className="table table-responsive table-sm table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                <th scope="col">Expense No.</th>
                                                                <th scope="col">Expense Type</th>
                                                                <th scope="col">Name</th>
                                                                <th scope="col">Amount</th>
                                                                <th scope="col">Attachment</th>
                                                                <th scope="col">Current Status</th>
                                                                <th scope="col">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                JobOrderExpenseList ?
                                                                    JobOrderExpenseList.length ?
                                                                        JobOrderExpenseList.map((v, i) => {
                                                                            return <tr>
                                                                                <td>{i + 1}</td>
                                                                                <td>{v.oe_unique_id}</td>
                                                                                <td>{v.expense_type ? v.expense_type.name : ""}</td>
                                                                                <td>{v.expense_name}</td>
                                                                                <td>{`${v.amount} ${v.expense_currency ? v.expense_currency.currency : ""}`}</td>
                                                                                <td>{v.attatchment ? <><Link to={`${adminMainUrl}/${v.attatchment}`} target='_blank' title='View Uploaded Attatchment'><i className='fa-solid fa-eye cursor-pointer text-blue'></i></Link></> : <i>No file uploaded.</i>}</td>
                                                                                <td>{v.current_status == "EXPENSE APPROVED" ? <><span className="text-success"><b>{v.current_status}</b></span></> : <>{v.current_status}</>}</td>
                                                                                <td>
                                                                                    {
                                                                                        v.current_status == "PICKED BY ACCOUNTS" ?
                                                                                            <button className="btn btn-sm btn-outline-success me-1" title='View & Approve Expense Details' onClick={() => { handleShow(v.id) }}><i className="fa-solid fa-check"></i></button>
                                                                                            : v.current_status == "EXPENSE APPROVED" ?
                                                                                                <button className="btn btn-sm btn-outline-primary me-1" title='View Expense Details' onClick={() => { handleShow(v.id) }}><i className="fa-solid fa-eye"></i></button>
                                                                                                : null
                                                                                    }
                                                                                    {/* <button className="btn btn-sm btn-outline-success ms-1" title="Approve the Expense"><i className="fa-solid fa-check"></i></button> */}
                                                                                </td>
                                                                            </tr>
                                                                        })
                                                                        :
                                                                        <tr>
                                                                            <td colSpan={7}>No Expense found</td>
                                                                        </tr> :
                                                                    <tr>
                                                                        <td colSpan={7}>Could not find Expense</td>
                                                                    </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                            </div>
                        </div>

                        {/* Show Query Details */}
                        <Offcanvas show={show} onHide={handleClose} placement={'end'}>
                            <Offcanvas.Header closeButton>
                                <Offcanvas.Title>Expense Details</Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                {
                                    viewCanvasLoader ?
                                        <Beatloader />
                                        :
                                        <div className="row">
                                            <div className="col-md-4 my-1">
                                                <label className='form-label-cus' htmlFor="Expenseno">Expense No:</label>
                                            </div>
                                            <div className="col-md-8 my-1">
                                                <>{ExpenseDetails ? ExpenseDetails.oe_unique_id : ""}</>
                                            </div>
                                            <div className="col-md-4 my-1">
                                                <label className='form-label-cus' htmlFor="Expensename">Name:</label>
                                            </div>
                                            <div className="col-md-8 my-1">
                                                <>{ExpenseDetails ? ExpenseDetails.expense_name : ""}</>
                                            </div>
                                            <div className="col-md-4 my-1">
                                                <label className='form-label-cus' htmlFor="Expensedescription">Description:</label>
                                            </div>
                                            <div className="col-md-8 my-1">
                                                <>{ExpenseDetails ? ExpenseDetails.description : ""}</>
                                            </div>
                                            <div className="col-md-4 my-1">
                                                <label className='form-label-cus' htmlFor="Expenseamount">Amount:</label>
                                            </div>
                                            <div className="col-md-8 my-1">
                                                <>{ExpenseDetails ? ExpenseDetails.amount : ""}</>
                                            </div>
                                            {ExpenseDetails.current_status == "EXPENSE APPROVED" && <>
                                                <div className="col-md-4 my-1">
                                                    <label className='form-label-cus' htmlFor="Expenseremark">Current Status:</label>
                                                </div>
                                                <div className="col-md-8 my-1">
                                                    <b className='text-success'>EXPENSE APPROVED</b>
                                                </div>
                                            </>}
                                            <div className="col-md-4 my-1">
                                                <label className='form-label-cus' htmlFor="Expenseremark">Remarks:</label>
                                            </div>
                                            <div className="col-md-8 my-1">
                                                <><button className="btn btn-sm btn-primary mx-1" type='button' title="View Remarks" onClick={() => { handleShowRemark(ExpenseDetails ? ExpenseDetails.id : null) }}><i className="fa-solid fa-comments"></i></button></>
                                                {/* <><button className="btn btn-sm btn-primary mx-1" type='button' title={!showRemarkInput ? "Add Remark" : "Hide Input"} onClick={() => { setShowRemarkInput(!showRemarkInput) }}><i className={`fa-solid fa-${showRemarkInput ? 'minus' : 'plus'}`}></i></button></> */}
                                            </div>

                                            {
                                                ExpenseDetails ?
                                                    <div className="text-center">
                                                        {
                                                            ExpenseDetails.current_status == "PICKED BY ACCOUNTS" ?
                                                                (
                                                                    airsea == "air" && impexp == "import" && accessedPermission.includes("account_ai_approve_expense") ||
                                                                    airsea == "air" && impexp == "export" && accessedPermission.includes("account_ae_approve_expense") ||
                                                                    airsea == "sea" && impexp == "import" && accessedPermission.includes("account_si_approve_expense") ||
                                                                    airsea == "sea" && impexp == "export" && accessedPermission.includes("account_se_approve_expense")
                                                                ) &&
                                                                <button className="btn btn-sm btn-outline-success" type="button" disabled={disableSubmit} onClick={() => { handleApprove(ExpenseDetails ? ExpenseDetails.id : null) }}>{disableSubmit ? <> <i className="fas fa-spinner fa-spin mx-1"></i>Approving... </> : <> <i className="fa-solid fa-check mx-1"></i> Approve</>}</button> :
                                                                ExpenseDetails.current_status == "EXPENSE APPROVED" ?
                                                                    // <button className="btn btn-sm btn-success" type="button">Approved</button> :
                                                                    null :
                                                                    null
                                                        }
                                                    </div>
                                                    : null
                                            }
                                        </div>
                                }
                            </Offcanvas.Body>
                        </Offcanvas>


                        {/* Remark Offcanvas */}
                        <Offcanvas show={showRemark} onHide={handleCloseRemark}>
                            <Offcanvas.Header closeButton>
                                <Offcanvas.Title>Remarks</Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                {
                                    loadingExpenseRemarks ?
                                        <Beatloader /> :
                                        ExpenseRemarksError ?
                                            <div className='text-center'>{ExpenseRemarksError}</div>
                                            :
                                            <>

                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <form onSubmit={formik.handleSubmit}>
                                                            <div className="col-md-4 my-1">
                                                                <label className='form-label-cus' htmlFor="Expenseremark">Add Remark:</label>
                                                            </div>
                                                            <div className="col-md-12 my-1">
                                                                <textarea
                                                                    className='form-control'
                                                                    name="account_remark"
                                                                    id="account_remark"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.account_remark}
                                                                ></textarea>
                                                            </div>
                                                            <div className="text-end my-1">
                                                                <button className="btn btn-sm btn-primary" type="submit" disabled={disableRemarkSubmit}>{disableRemarkSubmit ? <> <i className="fas fa-spinner fa-spin mx-1"></i>Adding... </> : <>Add New Remark</>}</button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                                {
                                                    remarkMessage.map((value, index) => {
                                                        return <Accordion defaultActiveKey={`${index}`} key={index} className='mb-3'>
                                                            <Accordion.Item eventKey={index.toString()} >
                                                                <Accordion.Header className='remark-accordion'>
                                                                    {/* {new Date(value?.created_at).toISOString().split('T')[0]}{" "} */}
                                                                    <div className="remark-header-content w-100 d-flex justify-content-between">
                                                                        <span className="remark-user remark-font-14">
                                                                            {value?.remark_sent_user_type == "ACCOUNT" ? <RoundedSmallButton alphabet={"A"} title={"Accounts"} /> : value.remark_sent_user_type == "OPERATION" ? <RoundedSmallButton alphabet={"O"} title={"Operation"} /> : null}
                                                                            {value?.remark_user_info ? `${value?.remark_user_info?.name} (${value?.remark_user_info?.role})` : "-"}
                                                                        </span>
                                                                        <div className='d-flex justify-content-start align-items-center gap-3'>
                                                                            <span className="remark-date remark-font-14">{formatDate(value?.createdAt)}</span>
                                                                            <span className="remark-date remark-font-14">{formatTime(value?.createdAt)}</span>
                                                                        </div>
                                                                    </div>
                                                                </Accordion.Header>
                                                                <Accordion.Body className="remark-accordion-body-show-query">
                                                                    {value?.remark}
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        </Accordion>
                                                    })
                                                }
                                            </>
                                }
                            </Offcanvas.Body>
                        </Offcanvas>
                    </>
            }


        </>

    )
}

export default ViewJobOrderAccountExpense